export const SPREEDLY_IFRAME_SCRIPT_ID = 'spreedly-iframe-script';

export const SPREEDLY_IFRAME_SCRIPT_SRC = 'https://core.spreedly.com/iframe/iframe-v1.min.js';
